<template>
  <div
    :class="[impersonateToken ? 'justify-between gap-x-8' : 'justify-end']"
    class="flex items-center flex-shrink-0 h-[72px] border-b border-white-800 pl-24 pr-40"
  >
    <el-alert v-if="impersonateToken" type="info" :closable="false" class="max-w-fit">
      <p class="font-medium">
        You are in impersonation mode, viewing <span class="font-bold">
          {{ user.impersonatedUserEmail }} </span> account. To exit, click
      </p>
      <AppButton action="default" type="button" class="shrink-0" @click="exitImpersonation" />
    </el-alert>

    <UserInfo />
  </div>
</template>

<script lang="ts" setup>
const { $router, $routeNames } = useGlobalProperties()

const { user } = storeToRefs(useAuthStore())

const impersonateToken = computed(() => {
  return cookieService.getCookie('impersonateToken')
})

function exitImpersonation () {
  cookieService.deleteCookie('impersonateToken')
  window.location.href = $router.resolve({ name: $routeNames.spencerAdminSchools }).href
}
</script>
